<template>
  <div class="n30-cross">
    <!-- 移动端loading -->
    <Loading v-if="isMobile && isLoading" />
    <!-- 主图 -->
    <CarMainBanner :is-mobile="isMobile"
      banner-name="N30° 环球穿越"
      :banner-url="imgUrlPrefix + mainBanner"
      :title="mainTitle"
      :sub-title="subTitle"
      @pageLoad="pageLoad"
    />

    <!-- 图文混排组件 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList" mobile-font-color="light" />

    <!-- 上下布局组件: 上文字+下图片 -->
    <CarUpTxtDownImg :is-mobile="isMobile" :txt-img-obj="carUpTxtDownImgObject" />

    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList3" mobile-font-color="light" />

    <!-- 图文混排组件 2 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList2" />

    <!-- 纯图片展示组件 -->


    <!-- 车辆系列展示组件-1行3列 -->
    <CarSeriesComponent :car-series-obj="carSeriesObj" />

    <!-- 用户社群共创组件-多行多列 -->
    <!-- <CarCommunityComponent :car-community-obj="carCommunityObj" /> -->

    <!-- 底部生活方式组件 -->
    <CarLifeComponent :bg-img="carLifeBg" />
  </div>
</template>

<script>
import { checkIsMobile } from '../utils/tools.js'
import Loading from '../components/Loading.vue'
import CarMainBanner from '../components/CarMainBanner.vue'
import CarTxtInImgList from '../components/CarTxtInImgList.vue'
import CarUpTxtDownImg from '../components/CarUpTxtDownImg.vue'
// import CarImgShow from '../components/CarImgShow.vue'
import CarSeriesComponent from '../components/CarSeriesComponents.vue'
// import CarCommunityComponent from '../components/CarCommunityComponent.vue'
import CarLifeComponent from '../components/CarLifeComponent.vue'
export default {
  components: {
    Loading,
    CarMainBanner,
    CarTxtInImgList,
    CarUpTxtDownImg,
    // CarImgShow,
    CarSeriesComponent,
    // CarCommunityComponent,
    CarLifeComponent,
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  computed: {
    mainBanner() {
      return this.isMobile ? 'm-N30CrossMain.jpg' : 'N30CrossMain.jpg'
    },
    mainTitle() {
      return this.isMobile ? 'N30° 致敬<br>每一段<br>传奇征途' : 'N30° 致敬每一段传奇征途'
    },
    subTitle() {
      return this.isMobile ? '时尚经典 极致越野' : '穿越极限，抵达自由'
    },
    carLifeBg() {
      return this.isMobile ? '/assets/images/m-n30-life-bg.jpg' : '/assets/images/n30-life-bg.jpg'
    },

    // 图文混排数据
    carTxtInImgList() {
      return [
        {
          tag: '',
          title: 'N30° 环球',
          desc: this.isMobile ? '致敬每一段经典传奇' : 'Expedition',
          img: this.imgUrlPrefix + 'sec1_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec1_1.jpg',
          txtLayout: 'center-top2',
        }
      ]
    },

    carTxtInImgList3() {
      return [
        {
          tag: '',
          title: this.isMobile ?'跨界多形态运兵车' : '跨界多形态运兵车',
          desc: this.isMobile ? '长轴全能硬派穿越座驾<br>以经典运兵车为蓝本<br>专为长途全域穿越、多人载物、野外旅居打造' : '长轴全能硬派穿越座驾，以经典运兵车为蓝本，专为<br>长途全域穿越、多人载物、野外旅居打造',
          img: this.imgUrlPrefix + 'sec2_2.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_1.jpg',
          txtLayout: 'center-top2',
        }
      ]
    },

    // 上下布局: 上文字+下图片数据
    carUpTxtDownImgObject() {
      return {
        title: this.isMobile ? '以北纬 30° <br>环球穿越线为灵感<br>承袭其无界远征<br>多场景适配的特质<br>打造多形态可变<br>全场景从容抵达的<br>终极穿越座驾' : '以北纬 30° 环球穿越线为灵感，承袭其无界远征、多场景适配的特质打造多形态可变、全场景从容抵达的终极穿越座驾',
        desc: this.isMobile ? 
          '北纬 30°，是地球上最具传奇色彩的穿越线<br>它串联起北美落基山脉的壮阔<br>中国雅丹的风蚀奇景<br>塔克拉玛干的浩瀚沙海<br>也延伸至撒哈拉的无垠荒漠与大西洋的汹涌波涛' : '北纬 30°，是地球上最具传奇色彩的穿越线。它串联起北美落基山脉的壮阔、中国雅丹的风蚀奇景、塔克拉玛干的浩瀚沙海，也延伸至撒哈拉的无垠荒漠与大西洋的汹涌波涛',
        imgList: [this.imgUrlPrefix + 'sec2_1.jpg'],
        mobileImg: this.imgUrlPrefix + 'm-sec2_1.jpg',
      }
    },

    // 图文混排数据 2
    carTxtInImgList2() {
      return [
        {
          tag: '',
          title: this.isMobile ? '经典运兵车<br>美学重构' : '经典运兵车美学重构',
          desc: '以经典硬派运兵车为设计灵感源点<br>保留纯粹的复古运兵车视觉基因<br>通过比例优化重构经典设计逻辑',
          img: this.imgUrlPrefix + 'sec3_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_2.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: this.isMobile ? '保留纯粹的复古<br>运兵车<br>视觉基因' :  '保留纯粹的复古运兵车<br>视觉基因',
          desc: this.isMobile ? '方正轮廓、垂直侧窗、平直车顶<br>高顶厢式车身<br>复刻硬派工具车的纯粹气质' : '方正轮廓、垂直侧窗、平直车顶、高顶厢式车身<br>复刻硬派工具车的纯粹气质',
          img: this.imgUrlPrefix + 'sec3_2.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_3.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: '全场景多形态可变',
          desc: '一台车覆盖旅居、重载、敞篷三大场景功能<br>是专为长途全域穿越、多人载物、野外旅居打造的跨界多形态运兵车',
          img: this.imgUrlPrefix + 'sec3_3.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_4.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: '基础舱态',
          desc: this.isMobile ? '后排竖排座椅采用「快拆 + 放倒」<br>双模式设计' : '后排竖排座椅采用「快拆 + 放倒」双模式设计',
          img: this.imgUrlPrefix + 'sec3_4.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_5.jpg',
          txtLayout: 'left-top',
        },
        // 0423新增3个模块
        {
          tag: '',
          title: '床车舱态',
          desc: this.isMobile ? '座椅放倒后<br>可拓展出1.9 米纯平床车空间<br>形成完整旅居平台' : '座椅放倒后，可拓展出1.9 米纯平床车空间，形成完整旅居平台',
          img: this.imgUrlPrefix + 'sec3_5.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_6.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: '露营舱态',
          desc: this.isMobile ? '舱内预留拓展接口<br>可加装木质桌板、储物系统、户外电源等配件' : '舱内预留拓展接口<br>可加装木质桌板、储物系统、户外电源等配件',
          img: this.imgUrlPrefix + 'sec3_6.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_7.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: '模块化平台',
          desc: this.isMobile ? '从车顶到车尾，从舱内到舱外<br>每一处预留都为你的穿越旅途留足想象空间<br>让一台车，成为你环球远征的全能移动基地' : '从车顶到车尾，从舱内到舱外<br>每一处预留都为你的穿越旅途留足想象空间<br>让一台车，成为你环球远征的全能移动基地',
          img: this.imgUrlPrefix + 'sec3_7.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec3_8.jpg',
          color: 'light',
          txtLayout: 'left-top',
        },
      ]
    },

    
    

  },
  data() {
    const imgUrlPrefix = '/assets/images/n30Cross/'
    const imgUrlPrefix2 = '/assets/images/n30Loki/'
    return {
      isLoading: true,
      isMobile: false,
      imgUrlPrefix, // 图片地址前缀
      
      // 纯图片展示数据
      carImgList: [imgUrlPrefix + 'sec4_1.jpg', imgUrlPrefix + 'sec4_2.jpg'],
      // 车辆系列数据
      carSeriesObj: {
        logo: imgUrlPrefix2 + 'series-logo.png',
        desc: '以「高端定制」为核，共创专属格调',
        title: 'CLASSIC N30° 系列',
        series: 'CLASSIC',
        carList: [
          { img: imgUrlPrefix2 + 'sec7_1.png', name: 'N30° 环球', link: ''},
          { img: imgUrlPrefix2 + 'sec7_2.png', name: 'N30° 洛基', link: 'N30Loki'},
          { img: imgUrlPrefix2 + 'sec7_3.png', name: 'N30° 雅丹', link: 'N30ThreeDoors'},
        ]
      },
      // 用户社群共创数据
      // carCommunityObj: {
      //   title: 'N30°用户社群共创',
      //   desc: 'N30°家族的模块化设计架构，天生为多元探索而生<br>它既承载了标准化量产的通用实力，量身打造专属越<br>野解决方案，陪你奔赴每一种远方。',
      //   imgList: [
      //     imgUrlPrefix2 + 'sec8_1.png', imgUrlPrefix2 + 'sec8_2.png', imgUrlPrefix2 + 'sec8_3.png', imgUrlPrefix2 + 'sec8_4.png',
      //     imgUrlPrefix2 + 'sec8_5.png', imgUrlPrefix2 + 'sec8_6.png', imgUrlPrefix2 + 'sec8_7.png', imgUrlPrefix2 + 'sec8_8.png',
      //     imgUrlPrefix2 + 'sec8_9.png', imgUrlPrefix2 + 'sec8_10.png', imgUrlPrefix2 + 'sec8_11.png', imgUrlPrefix2 + 'sec8_12.png',
      //   ]
      // },
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = checkIsMobile()
    },
    pageLoad() {
      this.isLoading = false
    }
  },
}
</script>

<style lang="less" scoped>
.n30-cross {
  font-weight: @fw2;
  font-family: 'TsangerYunHei', sans-serif;
}
</style>